if (!customElements.get('product-form')) {
  const ensureKalisaAtcFeedbackStyles = () => {
    if (document.getElementById('kalisa-atc-feedback-styles')) return;

    const style = document.createElement('style');
    style.id = 'kalisa-atc-feedback-styles';
    style.textContent = `
      product-form [type="submit"]:not([disabled]):not([aria-disabled="true"]):not(.kalisa-atc--loading):not(.kalisa-atc--added) {
        background: #681F32 !important;
        border-color: #681F32 !important;
        color: #ffffff !important;
        transition: background-color 180ms ease, border-color 180ms ease, color 180ms ease;
      }

      product-form [type="submit"].kalisa-atc--loading {
        background: #681F32 !important;
        border-color: #681F32 !important;
        color: #ffffff !important;
        opacity: 1 !important;
        cursor: wait;
      }

      product-form [type="submit"].kalisa-atc--added {
        background: #F5E8E3 !important;
        border-color: #681F32 !important;
        color: #681F32 !important;
        opacity: 1 !important;
      }

      product-form [type="submit"].kalisa-atc--added::before {
        content: "✓";
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-inline-end: 0.8rem;
        font-size: 1.8rem;
        line-height: 1;
        font-weight: 600;
        color: #681F32;
      }

      product-form [type="submit"].kalisa-atc--loading > span {
        opacity: 1 !important;
        visibility: visible !important;
      }

      product-form [type="submit"].kalisa-atc--loading .loading__spinner {
        position: static !important;
        display: inline-flex !important;
        width: 1.8rem;
        height: 1.8rem;
        margin-inline-start: 0.8rem;
        opacity: 1 !important;
        visibility: visible !important;
      }

      product-form [type="submit"].kalisa-atc--loading .loading__spinner svg {
        animation: kalisa-atc-spin 0.75s linear infinite;
        color: #ffffff !important;
      }

      product-form [type="submit"].kalisa-atc--loading .loading__spinner svg circle,
      product-form [type="submit"].kalisa-atc--loading .loading__spinner svg path {
        stroke: #ffffff !important;
      }

      @keyframes kalisa-atc-spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `;

    document.head.appendChild(style);
  };

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        ensureKalisaAtcFeedbackStyles();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.kalisaSubmitting = false;
        this.cart = null; // Add-to-cart success routes to the full cart page.
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButtonDefaultText = this.submitButtonText?.textContent?.trim() || window.variantStrings.addToCart;

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {

        evt.preventDefault();
        if (this.kalisaSubmitting || this.submitButton.getAttribute('aria-disabled') === 'true') return;

this.kalisaSubmitting = true;
        this.handleErrorMessage();
        this.error = false;

        this.setButtonLoadingState();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then(async (response) => {
            const data = await response.json();
            if (!response.ok && !data.status) data.status = response.status;
            return data;
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.error = true;
              this.handleErrorMessage(typeof response.description === 'string' ? response.description : window.cartStrings.error);

              return;
            } else if (!this.cart) {
              this.setButtonAddedState();
              window.location.assign(window.routes.cart_url);
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            this.setButtonAddedState();
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(window.cartStrings.error);
            this.error = true;
          })
          .finally(() => {
            this.kalisaSubmitting = false;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            if (this.error) {
              this.resetButtonFeedbackState();
              return;
            }

            setTimeout(() => {
              this.resetButtonFeedbackState();
            }, 2500);
          });
      }

      setButtonLoadingState() {
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButtonDefaultText = this.submitButtonText?.textContent?.trim() || this.submitButtonDefaultText;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.remove('kalisa-atc--added');
        this.submitButton.classList.add('loading', 'kalisa-atc--loading');
        if (this.submitButtonText) this.submitButtonText.textContent = 'Adding...';
        this.querySelector('.loading__spinner')?.classList.remove('hidden');
      }

      setButtonAddedState() {
        this.submitButton.removeAttribute('aria-busy');
        this.submitButton.classList.remove('loading', 'kalisa-atc--loading');
        this.submitButton.classList.add('kalisa-atc--added');
        if (this.submitButtonText) this.submitButtonText.textContent = 'Added to cart';
        this.querySelector('.loading__spinner')?.classList.add('hidden');
      }

      resetButtonFeedbackState() {
        this.submitButton.removeAttribute('aria-busy');
        this.submitButton.classList.remove('loading', 'kalisa-atc--loading', 'kalisa-atc--added');
        const unavailable = this.submitButton.disabled || this.variantIdInput.disabled || !this.variantIdInput.value;
        if (unavailable) {
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
          if (this.submitButtonText) this.submitButtonText.textContent =
            this.dataset.kalisaCustomSizeEdit === 'true' ? 'Update Custom Size' : this.submitButtonDefaultText;
        }
        this.querySelector('.loading__spinner')?.classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButton.getAttribute('aria-busy') !== 'true') this.submitButton.removeAttribute('aria-disabled');
          const editText = window.variantStrings.addToCart;
          this.submitButtonText.textContent = editText;
          this.submitButtonDefaultText = editText;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

